import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const LanguageSelector = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const currentLang = searchParams.get('lang') || 'en';

  const handleChange = (event) => {
    const newLang = event.target.value;
    const updatedParams = new URLSearchParams(searchParams);
    updatedParams.set('lang', newLang);
    navigate(`${location.pathname}?${updatedParams.toString()}`, { replace: true });
    localStorage.setItem('selectedLocale', newLang); // 🔥 Salva no navegador
  };

  // Quando o componente monta, se não houver `lang` na URL, tenta carregar do localStorage
  useEffect(() => {
    const savedLocale = localStorage.getItem('selectedLocale');
    if (!searchParams.get('lang') && savedLocale) {
      const updatedParams = new URLSearchParams(searchParams);
      updatedParams.set('lang', savedLocale);
      navigate(`${location.pathname}?${updatedParams.toString()}`, { replace: true });
    }
  }, [location.pathname, navigate, searchParams]);

  return (
    <>
      <select
        id="language-select"
        name="language"
        value={currentLang}
        onChange={handleChange}
      >
        <option value="en">English</option>
        <option value="pt">Português</option>
        <option value="es">Español</option>
      </select>
    </>
  );
};

export default LanguageSelector;
